module.exports = __webpack_public_path__ + "img/47.d66b3416.jpg";